<template>
  <v-card flat>
    <v-card-item>
      <template v-slot:prepend>
        <v-avatar color="secondary" size="small">
          <v-icon icon="mdi-bullseye-arrow"></v-icon>
        </v-avatar>
      </template>
      <v-card-title class="text-subtitle-1 text-primary">
        {{ $t("labels.title-target") }}
      </v-card-title>
      <v-card-subtitle class="text-caption">
        {{ $t("strings.target-hint") }}
        <v-tooltip activator="parent" location="top">
          {{ $t("strings.target-hint") }}
        </v-tooltip>
      </v-card-subtitle>
    </v-card-item>
    <v-card-text class="pt-2">
      <v-row>
        <v-col cols="5">
          <v-text-field
            v-model="targetValue"
            :label="$t('labels.value')"
            variant="outlined"
            :rules="numberRules"
            required
            density="compact"
            name="targetValue"
            hide-details="auto"
          ></v-text-field>
        </v-col>
        <v-col cols="7">
          <v-autocomplete
            v-model="selectedMeasure"
            variant="outlined"
            :items="unitMeasuresArray"
            density="compact"
            :label="$t('labels.unitMeasure')"
            name="unitMeasure"
            required
            :rules="measureRules"
            hide-details="auto"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: [
    "symbolsUnitsMeasures",
    "parentTargetValue",
    "parentUnitMeasure",
    "parentValidFields",
    "realm",
  ],
  emits: ["writeTargetValue", "writeUnitMeasure"],
  data() {
    return {
      numberRules: [
        (v) => {
          this.formatTargetValue(v);
          return true; // Ensure this rule always returns true
        },
        (v) => !!v || this.$t("labels.required"), // Ensure a boolean or string is returned
        (v) =>
          !["-", "-0", "-0.", "-."].includes(v) ||
          this.$t("strings.number-hint"),
      ],
      measureRules: [(v) => !!v || this.$t("labels.required")], // Ensure a boolean or string is returned
      targetValue: this.parentTargetValue,
      selectedMeasure: this.parentUnitMeasure,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.targetValue = this.parentTargetValue;
      this.selectedMeasure = this.parentUnitMeasure;
    });
  },

  watch: {
    selectedMeasure(value) {
      this.$emit("writeUnitMeasure", value);
    },
  },
  computed: {
    unitMeasuresArray() {
      return this.createUnitArray(this.symbolsUnitsMeasures);
    },
  },
  methods: {
    createUnitArray(unitSymbols) {
      const unitArray = Object.entries(unitSymbols).map(([key, value]) => {
        const title = this.$t(`measures.${key}`);
        return {
          title: `${title} - ${value}`,
          value: key,
        };
      });
      unitArray.unshift({ title: this.$t(`measures.NONE`), value: "None" });
      return unitArray;
    },

    formatTargetValue(value) {
      if (value == null) {
        value = ""; // Ensure value is a string if null or undefined
      } else if (typeof value !== "string") {
        value = value.toString(); // Convert non-string values to string
      }

      // Replace invalid characters with an empty string
      value = value.replace(/[^0-9,.-]/g, "");
      // Replace all '.' with ','
      value = value.replace(/,/g, ".");
      // Ensure the dot is not at the beginning
      if (value.startsWith(".")) {
        value = value.substring(1);
      }
      // Ensure the dot is not immediately after a minus sign
      value = value.replace(/-\./, "-");
      // Ensure '-' only appears at the start
      value = value.replace(/(?!^)-/g, "");
      // Split the value by commas to check positions of hyphens
      let parts = value.split(".");
      // Keep only the first comma
      if (parts.length > 2) {
        parts = [parts.slice(0, 2).join(".")];
      }
      for (let i = 0; i < parts.length; i++) {
        if (parts[i].indexOf("-") > 0) {
          // If hyphen is not at the start, remove it
          parts[i] = parts[i].replace("-", "");
        }
      }
      // Join the parts back together with commas
      value = parts.join(".");

      this.targetValue = value;
      this.$emit("writeTargetValue", value);
    },
  },
};
</script>
